import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BusinessUser } from 'src/app/models/business-user.model';
import { MgService } from 'src/app/services/mg.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-user-change-password',
  templateUrl: './user-change-password.component.html',
  styleUrls: ['./user-change-password.component.scss']
})
export class UserChangePasswordComponent implements OnInit {
  public form: UntypedFormGroup;
  public status: 'W' | 'L' | 'S' | 'E' = 'W';

  constructor(
    private fb: UntypedFormBuilder,
    private api: MgService,
    private auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      user: [undefined, Validators.required],
      password: [undefined, Validators.required],
      password_confirmation: [undefined, Validators.required],
    });
  }

  public onSubmit() {
    this.status = 'L'
    this.form.controls.user.setValue(this.auth.user.id);
    this.api.changeBusinessUserPassword(this.form.value)
      .subscribe(
        res => this.status = 'S',
        err => this.status = 'E',
      )
  }

}
